import React from 'react';

class PaginationButton extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			observer: new window.IntersectionObserver(([entry]) => {
				if (entry.isIntersecting) {
					this.props.fetchMore();
					return;
				}
			}, {
				root: null,
				threshold: 0.1
			})
		};
	}
	componentDidMount() {
		this.state.observer.observe(document.querySelector('#pagination-button-offers'));
	}
	componentWillUnmount() {
		this.state.observer.unobserve(document.querySelector('#pagination-button-offers'));
	}
	render() {
		const { fetchMore, intl } = this.props;

		return (
			<button
				className="ui-btn ui-btn-secondary"
				id="pagination-button-offers"
				onClick={() => fetchMore()}
			>
				{intl('Show more')}
			</button>
		);
	}
}

export default PaginationButton;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/components/table/paginationButton.js